import { Component, OnInit } from '@angular/core';
import { PoliticaSenha } from '../shared/model/politica-senha';
import { SegurancaService } from '../shared/service/seguranca/seguranca.service';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../shared/service/login/login.service';
import { UtilService } from '../shared/service/util/util.service';

@Component({
    selector: 'app-seguranca',
    templateUrl: './seguranca.component.html',
    styleUrls: ['./seguranca.component.css']
})
export class SegurancaComponent implements OnInit {

    politicaSenha: PoliticaSenha;
    utilizarSegurancaPIN: boolean;

    constructor(
        private segurancaService: SegurancaService,
        private route: ActivatedRoute,
        private loginService: LoginService,
        private utilService: UtilService) {

    }

    ngOnInit() {
        this.politicaSenha = this.route.snapshot.data['obterPoliticaSenha'];
        this.utilizarSegurancaPIN = this.politicaSenha.id != null;
    }

    salvar() {
        let organizacaoID = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;

        this.politicaSenha = new PoliticaSenha();
        this.politicaSenha.organizacaoId = organizacaoID;

        if (this.utilizarSegurancaPIN) {
            this.politicaSenha.id = 1;
        }

        this.segurancaService.salvar(this.politicaSenha).subscribe(
            res => {
                this.utilService.showSuccess("Dados atualizados com sucesso.");
            },
            err => {
                this.utilService.showError(err.message);

                if (err.status === 401 || err.status === 403) {
                    this.loginService.logout();
                }
            }
        );
    }
}